<template>
    <v-container class="ma-0 pa-0 pb-8">
        <v-row class="pt-10 px-8 pb-12">
            <strong>Filtros</strong>
            <v-spacer></v-spacer>
            <v-btn @click="removeFilter()" small class="elevation-0" style="border:solid 1px #dddddd;">
                <v-icon small class="mr-1">mdi-filter-off</v-icon>Limpiar
            </v-btn>

            <v-autocomplete @keydown.enter="filter()" v-model="activity.activity_type_id" :items="activityLists" hide-no-data item-value="id" item-text="name" label="Tipo" placeholder="Escribe para buscar" attach chips multiple></v-autocomplete>

            <v-text-field @keydown.enter="filter()" label="Titulo" v-model="activity.title"></v-text-field>
            
            <!--v-autocomplete @keydown.enter="filter()" v-model="activity.user_id" :items="userList" hide-no-data item-value="id" item-text="name" label="Usuario(s)" placeholder="Escribe para buscar" attach chips multiple></v-autocomplete-->

            <!--v-menu offset-y :close-on-content-click="closeDatePicker(activity.date)">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field clearable v-model="activity.date" label="Fecha" prepend-icon="mdi-calendar" v-bind="attrs" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="activity.date" range></v-date-picker>
            </v-menu>

            <v-menu offset-y :close-on-content-click="closeDatePicker(activity.created_at)">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field clearable v-model="activity.created_at" label="Fecha Creación" prepend-icon="mdi-calendar" v-bind="attrs" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="activity.created_at" range></v-date-picker>
            </v-menu>

            <v-menu offset-y :close-on-content-click="closeDatePicker(activity.updated_at)">
                <template v-slot:activator="{ on, attrs }">
                    <v-text-field clearable v-model="activity.updated_at" label="Fecha Edición" prepend-icon="mdi-calendar" v-bind="attrs" readonly v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="activity.updated_at" range></v-date-picker>
            </v-menu-->

            <!--v-select @keydown.enter="filter()" label="Realizada" v-model="activity.completed" :items="statuses"></v-select-->

            <v-text-field @keydown.enter="filter()" label="Descripción" v-model="activity.description"></v-text-field>

        </v-row>
        <v-card style="position:absolute; bottom:0; width:100%;" tile color="primary">
            <v-list-item link @click="filter()" dark>
                <v-list-item-content>
                    <strong>Filtrar (0)</strong>
                </v-list-item-content>
            </v-list-item>    
        </v-card>
    </v-container>
</template>

<script>
import axios from "axios";
export default {
    data: () => ({
        statuses:[{text:'Realizado', value:1}, {text:'No Realizado', value:0}],//{text:'Pendiente', value:'Pending'}, 
        activity:{
            //user_id:[],
            description:'',
            //completed:'',
            date:[],
            created_at:[],
            updated_at:[],
            activity_type_id:'',
            title:''
        },
    }),
    computed:{
        liga(){
            return process.env.VUE_APP_BACKEND_ROUTE
        },
        userList(){
            return this.$store.state.user.users.map(id => {
                return{
                    id:id.id,
                    name:id.name + id.last,
                }
            })
        },
        currentUser:{
            get(){
                return this.$store.state.currentUser.user
            }
        },
        activityLists(){
                return this.$store.state.activity.activities;
            }, 
    },
    created(){
        if(localStorage.getItem('filtersActivities')!=undefined){
            this.activity = JSON.parse(localStorage.getItem('filtersActivities'))
            this.entries = JSON.parse(localStorage.getItem('entriesFiltersActivities'))
        }
    },
    mounted(){
        if(localStorage.getItem('filtersActivities')!=undefined){
            this.activity = JSON.parse(localStorage.getItem('filtersActivities'))
            this.entries = JSON.parse(localStorage.getItem('entriesFiltersActivities'))
        }
    },
    methods:{
        closeDatePicker(dates){
            if(dates!=undefined && dates.length==2){
                return true
            }else{
                return false
            }
        },
        filter(){
            var count = 0
            var filter = ''
            //abierto
            if(this.activity.description!=''){
                count = count+1
                filter = filter + '&filter[description]='+this.activity.description
            }
            if(this.activity.title!=''){
                count = count+1
                filter = filter + '&filter[title]='+this.activity.title
            }
            if(this.activity.activity_type_id!=''){
                count = count+1
                filter = filter + '&filter[activity_type_id]='+this.activity.activity_type_id
            }
            if(this.activity.user_id!=undefined && this.activity.user_id.length>0){
                count = count+1
                filter = filter + '&filter[user_id]='
                var length = this.activity.user_id.length
                for(var i=0; i<length; i++){
                    filter = filter + this.activity.user_id[i]
                    if(length>1 && i<length-1){
                        filter = filter + ','
                    }
                }
            }
            if(this.activity.completed!==undefined&&this.activity.completed!==''){
                count = count+1
                if(this.activity.completed==true){
                    filter = filter + '&filter[completed]='+this.activity.completed
                }else{
                    filter = filter + '&filter[completed]='+this.activity.completed//+','+false
                }
            }
            if(this.activity.date!=undefined && this.activity.date.length==2){
                count = count+1
                filter = filter + '&filter[date_between]=' + this.activity.date[0] + ',' + this.activity.date[1]
            }
            if(this.activity.created_at!=undefined && this.activity.created_at.length==2){
                count = count+1
                filter = filter + '&filter[created_between]=' + this.activity.created_at[0] + ',' + this.activity.created_at[1]
            }
            if(this.activity.updated_at!=undefined && this.activity.updated_at.length==2){
                count = count+1
                filter = filter + '&filter[updated_between]=' + this.activity.updated_at[0] + ',' + this.activity.updated_at[1]
            }
            localStorage.setItem('selectorFiltersActivities', JSON.stringify(this.activity));
            localStorage.setItem('entriesFiltersActivities', JSON.stringify(this.entries));
            localStorage.setItem('filtersActivities', JSON.stringify(filter));
            localStorage.setItem('filtersActivitiesLength', count)
            this.$nextTick(() => {
                this.$emit("filtersActivities", false);
            })
        },
        removeFilter(){
            this.activity={
                //user_id:[],
                description:'',
                //completed:'',
                date:[],
                created_at:[],
                updated_at:[],
                activity_type_id:'',
                title:''
            },
            localStorage.removeItem("selectorFiltersActivities")
            localStorage.removeItem("filtersActivities")
            localStorage.removeItem("entriesFiltersActivities")
            localStorage.removeItem("filtersActivitiesLength")
            this.$nextTick(() => {
                this.$emit("filtersActivities", false);
            })
        }
    }
}
</script>